export const features = [
  {
    icon: "ri-4k-line",
    title: "高清画质",
    desc: "全站支持 1080P 与 4K 超清画质，智能码率自适应，无论大屏小屏都能享受影院级观影体验，拒绝模糊与马赛克。",
  },
  {
    icon: "ri-advertisement-line",
    title: "纯净免广告",
    desc: "全程无贴片广告、无弹窗、无强制插播，打开即看，追剧一气呵成。我们承诺：不播放任何形式的视频广告。",
  },
  {
    icon: "ri-flashlight-line",
    title: "极速不卡顿",
    desc: "全球多节点 CDN 加速，智能预加载技术确保播放流畅不缓冲。地铁、高铁、家中，随时随地流畅追剧。",
  },
];

export const updates = [
  {
    date: "2026.07.30",
    tag: "上新",
    title: "《长安的荔枝》全集上线",
    desc: "马伯庸同名小说改编，雷佳音、岳云鹏领衔主演，大唐小吏的荔枝转运传奇现已完结。",
  },
  {
    date: "2026.07.29",
    tag: "热播",
    title: "《乌云之上》更新至第 18 集",
    desc: "孙俪、罗晋再度联手，悬疑刑侦剧口碑持续走高，单集播放量突破 8000 万。",
  },
  {
    date: "2026.07.28",
    tag: "完结",
    title: "《棋士》大结局已更新",
    desc: "王宝强监制并主演，围棋题材犯罪悬疑剧全 22 集已上线，豆瓣开分 8.7。",
  },
  {
    date: "2026.07.27",
    tag: "上新",
    title: "《藏海传》首播上线",
    desc: "肖战、张婧仪主演古装权谋大剧，改编自南派三叔同名小说，首日 8 集连播。",
  },
  {
    date: "2026.07.26",
    tag: "热播",
    title: "《沙尘暴》持续热播中",
    desc: "段奕宏、王锵主演刑侦悬疑剧，西北小镇连环命案引发全国追剧热潮。",
  },
  {
    date: "2026.07.25",
    tag: "推荐",
    title: "《黄雀》口碑黑马突围",
    desc: "郭京飞、秦岚主演反扒题材剧，开播两周豆瓣评分从 7.2 升至 8.4。",
  },
  {
    date: "2026.07.24",
    tag: "专题",
    title: "「暑期古装片单」专题上线",
    desc: "精选《长相思2》《柳舟记》《四海重明》等 20 部暑期必看古装剧，一键加入追剧列表。",
  },
];

export const mediaItems = [
  {
    img: "https://readdy.ai/api/search-image?query=Chinese%20historical%20costume%20drama%20scene%2C%20Tang%20Dynasty%20palace%20interior%20with%20warm%20candlelight%2C%20elegant%20characters%20in%20traditional%20silk%20robes%2C%20cinematic%20lighting%2C%20soft%20golden%20tones%2C%20film%20grain%20texture&width=640&height=360&seq=media-01&orientation=landscape",
    title: "长安的荔枝",
    tag: "古装传奇",
    views: "2.8亿",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Modern%20crime%20investigation%20drama%20scene%2C%20two%20detectives%20in%20dimly%20lit%20interrogation%20room%2C%20suspenseful%20atmosphere%2C%20blueish%20tinted%20cinematic%20lighting%2C%20film%20noir%20style%2C%20dramatic%20shadows&width=640&height=360&seq=media-02&orientation=landscape",
    title: "乌云之上",
    tag: "刑侦悬疑",
    views: "1.6亿",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Chinese%20Go%20chess%20board%20closeup%20with%20black%20and%20white%20stones%2C%20moody%20atmospheric%20lighting%2C%20man%20hand%20placing%20stone%2C%20crime%20thriller%20aesthetic%2C%20dark%20wooden%20table%2C%20cinematic%20depth%20of%20field&width=640&height=360&seq=media-03&orientation=landscape",
    title: "棋士",
    tag: "犯罪剧情",
    views: "1.2亿",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Desert%20landscape%20with%20sandstorm%20approaching%20small%20northwest%20Chinese%20town%2C%20dusty%20golden%20atmosphere%2C%20abandoned%20buildings%2C%20cinematic%20wide%20shot%2C%20warm%20sepia%20tones%2C%20dramatic%20sky&width=640&height=360&seq=media-04&orientation=landscape",
    title: "沙尘暴",
    tag: "刑侦悬疑",
    views: "9800万",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20court%20political%20drama%20scene%2C%20grand%20throne%20room%20with%20golden%20dragon%20decorations%2C%20officials%20in%20traditional%20Ming%20dynasty%20costumes%2C%20warm%20dramatic%20lighting%2C%20cinematic%20composition&width=640&height=360&seq=media-05&orientation=landscape",
    title: "藏海传",
    tag: "古装权谋",
    views: "2.1亿",
  },
];

export const rankingItems = [
  { rank: 1, title: "藏海传", tag: "古装权谋", heat: "热播榜 TOP1", change: "up" as const },
  { rank: 2, title: "长安的荔枝", tag: "古装传奇", heat: "完结榜 TOP2", change: "up" as const },
  { rank: 3, title: "乌云之上", tag: "刑侦悬疑", heat: "热搜 TOP3", change: "up" as const },
  { rank: 4, title: "棋士", tag: "犯罪剧情", heat: "口碑榜 TOP4", change: "new" as const },
  { rank: 5, title: "沙尘暴", tag: "刑侦悬疑", heat: "飙升榜 TOP5", change: "up" as const },
  { rank: 6, title: "黄雀", tag: "反扒题材", heat: "黑马榜 TOP6", change: "new" as const },
];

export const carouselItems = [
  {
    img: "https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20palace%20political%20drama%20key%20visual%2C%20dramatic%20lighting%20with%20golden%20and%20crimson%20tones%2C%20grand%20scale%20cinematic%20composition%2C%20traditional%20architecture%20silhouette%2C%20misty%20atmosphere&width=800&height=450&seq=carousel-01&orientation=landscape",
    title: "权谋风云：2026 暑期古装大剧专题",
    desc: "藏海传、长安的荔枝、柳舟记等年度重磅古装剧全面上线，权谋智斗与传奇史诗交织，这个夏天必追的古装盛宴。",
    tag: "专题策划",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Suspenseful%20crime%20scene%20with%20police%20tape%20and%20evidence%20markers%2C%20moody%20night%20lighting%2C%20rainy%20urban%20street%2C%20cinematic%20noir%20style%2C%20high%20contrast%20shadows%2C%20investigative%20atmosphere&width=800&height=450&seq=carousel-02&orientation=landscape",
    title: "悬疑剧场：烧脑刑侦剧合集",
    desc: "乌云之上、沙尘暴、棋士、黄雀四部口碑刑侦剧同档竞争，每一部都让你欲罢不能，烧脑程度层层升级。",
    tag: "类型推荐",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Warm%20family%20living%20room%20with%20large%20TV%20screen%20displaying%20colorful%20content%2C%20cozy%20evening%20atmosphere%2C%20popcorn%20and%20drinks%20on%20coffee%20table%2C%20modern%20home%20interior%2C%20soft%20ambient%20lighting&width=800&height=450&seq=carousel-03&orientation=landscape",
    title: "暑期追剧指南：全家一起看的好剧",
    desc: "从小朋友爱看的动画新番到长辈喜欢的年代剧，我们整理了适合全年龄段共享的暑期追剧清单。",
    tag: "追剧指南",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Classic%20Chinese%20drama%20nostalgic%20collage%20style%2C%20vintage%20film%20posters%20aesthetic%2C%20warm%20amber%20and%20sepia%20tones%2C%20old%20television%20set%2C%20memories%20theme%2C%20artistic%20double%20exposure%20composition&width=800&height=450&seq=carousel-04&orientation=landscape",
    title: "经典重温：豆瓣 9 分以上华语剧",
    desc: "从《大明王朝1566》到《漫长的季节》，盘点那些经得起时间考验的华语神剧，每一部都值得反复品味。",
    tag: "经典回顾",
  },
];

export const indexItems = [
  { title: "古装传奇", count: 486, img: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20architecture%20with%20flowing%20silk%20curtains%2C%20traditional%20lanterns%2C%20warm%20golden%20evening%20light%2C%20ethereal%20atmosphere%2C%20cinematic%20depth%2C%20soft%20focus%20background&width=400&height=250&seq=index-01&orientation=landscape" },
  { title: "刑侦悬疑", count: 312, img: "https://readdy.ai/api/search-image?query=Dark%20mysterious%20alley%20at%20night%20with%20single%20streetlamp%2C%20wet%20pavement%20reflections%2C%20urban%20noir%20atmosphere%2C%20cinematic%20lighting%2C%20film%20noir%20style%2C%20dramatic%20shadows&width=400&height=250&seq=index-02&orientation=landscape" },
  { title: "都市情感", count: 528, img: "https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20sunset%2C%20warm%20romantic%20atmosphere%2C%20couple%20silhouette%20on%20rooftop%2C%20soft%20pink%20and%20golden%20sky%2C%20cinematic%20composition%2C%20dreamy%20bokeh&width=400&height=250&seq=index-03&orientation=landscape" },
  { title: "年代大剧", count: 198, img: "https://readdy.ai/api/search-image?query=Vintage%201980s%20Chinese%20street%20scene%20with%20old%20bicycles%20and%20traditional%20shop%20signs%2C%20warm%20nostalgic%20sepia%20tones%2C%20golden%20hour%20lighting%2C%20cinematic%20film%20grain&width=400&height=250&seq=index-04&orientation=landscape" },
  { title: "科幻奇幻", count: 156, img: "https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20cityscape%20with%20neon%20lights%20and%20floating%20structures%2C%20sci-fi%20aesthetic%2C%20cyberpunk%20atmosphere%2C%20purple%20and%20teal%20color%20palette%2C%20cinematic%20wide%20shot&width=400&height=250&seq=index-05&orientation=landscape" },
  { title: "喜剧欢乐", count: 267, img: "https://readdy.ai/api/search-image?query=Bright%20colorful%20Chinese%20comedy%20stage%20set%20with%20warm%20spotlights%2C%20cheerful%20atmosphere%2C%20red%20and%20golden%20theater%20curtains%2C%20playful%20lighting%2C%20cinematic%20wide%20composition&width=400&height=250&seq=index-06&orientation=landscape" },
  { title: "战争历史", count: 143, img: "https://readdy.ai/api/search-image?query=Epic%20historical%20battlefield%20landscape%20with%20ancient%20Chinese%20banners%20and%20armor%2C%20dramatic%20sky%20with%20golden%20sunlight%2C%20cinematic%20scale%2C%20misty%20mountains%20background%2C%20heroic%20atmosphere&width=400&height=250&seq=index-07&orientation=landscape" },
  { title: "青春校园", count: 234, img: "https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20university%20campus%20with%20cherry%20blossoms%2C%20young%20students%20walking%20on%20tree-lined%20path%2C%20spring%20sunlight%2C%20fresh%20and%20youthful%20atmosphere%2C%20cinematic%20composition%2C%20soft%20focus&width=400&height=250&seq=index-08&orientation=landscape" },
];

export const aboutInfo = {
  title: "关于天堂影视",
  paragraphs: [
    "天堂影视成立于 2018 年，是国内领先的电视剧全集免费在线观看平台，致力于为追剧爱好者提供高清、流畅、免广告的优质观影体验。平台汇聚了海量国产剧、港台剧、日韩剧及欧美剧资源，涵盖古装传奇、刑侦悬疑、都市情感、年代大剧、科幻奇幻等全品类内容。",
    "我们与多家主流内容提供商深度合作，确保剧集资源每日更新，新剧上线 24 小时内即可同步观看。技术团队自主研发的智能码率自适应引擎与全球 CDN 加速网络，让每一位用户无论使用何种设备、身处何地，都能享受不缓冲不卡顿的流畅追剧体验。",
    "天堂影视始终坚持「用户至上」的理念，全站不插入任何形式的贴片广告与弹窗广告，让追剧回归纯粹的快乐。未来我们将持续拓展内容库，优化播放技术，做追剧党最值得信赖的在线观剧平台。",
  ],
  stats: [
    { value: "12,000+", label: "剧集资源" },
    { value: "3,200万", label: "月活用户" },
    { value: "99.7%", label: "播放成功率" },
    { value: "30+", label: "内容品类" },
  ],
};

export const topics = [
  { name: "藏海传", heat: "236万讨论" },
  { name: "长安的荔枝", heat: "189万讨论" },
  { name: "乌云之上", heat: "156万讨论" },
  { name: "暑期追剧", heat: "128万讨论" },
  { name: "棋士大结局", heat: "112万讨论" },
  { name: "肖战新剧", heat: "98万讨论" },
  { name: "悬疑剧推荐", heat: "87万讨论" },
  { name: "古装剧天花板", heat: "76万讨论" },
  { name: "沙尘暴凶手", heat: "65万讨论" },
  { name: "孙俪回归", heat: "58万讨论" },
];

export const comments = [
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20woman%2C%20warm%20friendly%20expression%2C%20clean%20white%20background%2C%20soft%20studio%20lighting%2C%20natural%20look&width=80&height=80&seq=avatar-01&orientation=squarish",
    name: "追剧小达人",
    time: "2 小时前",
    content: "天堂影视真的太良心了！没有广告这一点已经秒杀其他平台了，而且画质真的高清，晚上躺在床上用平板看《藏海传》，简直享受。已经推荐给全办公室同事了！",
    likes: 1286,
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20middle-aged%20Chinese%20man%2C%20friendly%20smile%2C%20clean%20neutral%20background%2C%20soft%20studio%20lighting%2C%20natural%20professional%20look&width=80&height=80&seq=avatar-02&orientation=squarish",
    name: "老张看剧",
    time: "5 小时前",
    content: "作为一个看了 20 年电视剧的老剧迷，天堂影视的片库真的让我惊喜。很多老剧在其他平台都下架了，这里居然还有高清版本。《大宅门》《康熙王朝》这些经典反复刷都不腻。",
    likes: 843,
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20woman%20with%20glasses%2C%20intelligent%20friendly%20look%2C%20clean%20background%2C%20soft%20studio%20lighting%2C%20natural%20expression&width=80&height=80&seq=avatar-03&orientation=squarish",
    name: "剧荒拯救者",
    time: "1 天前",
    content: "暑期剧荒的时候发现了天堂影视，那个「暑期古装片单」专题做得太贴心了，一口气标记了 10 部想看的，每天下班回来追两集，生活瞬间有了盼头。更新速度也没得说。",
    likes: 657,
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Chinese%20man%2C%20confident%20friendly%20smile%2C%20clean%20background%2C%20soft%20studio%20lighting%2C%20natural%20professional%20headshot&width=80&height=80&seq=avatar-04&orientation=squarish",
    name: "影评人阿磊",
    time: "2 天前",
    content: "从专业角度看，天堂影视的码率优化做得非常出色。我在多个设备上测试过，包括 4K 显示器、iPad 和手机，播放流畅度确实做到了不缓冲不卡顿，这一点在免费平台里极为罕见。",
    likes: 1523,
  },
];

export const contactInfo = {
  title: "联系我们",
  desc: "如果您有好的剧集推荐、合作意向或任何建议，欢迎通过以下方式与我们取得联系。天堂影视团队期待听到您的声音。",
  email: "contact@tiantangtv.com",
  wechat: "tiantangtv_official",
  qq: "800123456",
};

export const cardItems = [
  {
    img: "https://readdy.ai/api/search-image?query=Luxurious%20Tang%20Dynasty%20imperial%20garden%20with%20blooming%20peonies%2C%20ornate%20pavilion%2C%20golden%20afternoon%20light%2C%20elegant%20Chinese%20aesthetic%2C%20cinematic%20depth%2C%20soft%20atmospheric%20haze&width=600&height=350&seq=card-01&orientation=landscape",
    title: "古装剧穿搭图鉴",
    desc: "从《藏海传》的明代官服到《长安的荔枝》的唐风霓裳，带你领略古装剧中的服饰美学。",
    tag: "文化解读",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Dimly%20lit%20crime%20investigation%20room%20with%20evidence%20board%20covered%20in%20photos%20and%20red%20strings%2C%20desk%20lamp%20casting%20dramatic%20shadows%2C%20mysterious%20atmosphere%2C%20cinematic%20noir&width=600&height=350&seq=card-02&orientation=landscape",
    title: "悬疑剧推理指南",
    desc: "《乌云之上》《沙尘暴》等热播悬疑剧线索全梳理，帮你理清案情脉络，看懂每一个伏笔。",
    tag: "深度解析",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Warm%20cozy%20home%20theater%20setup%20with%20large%20TV%20and%20comfortable%20sofa%2C%20soft%20ambient%20lighting%2C%20snacks%20and%20drinks%2C%20cinematic%20evening%20mood%2C%20relaxing%20atmosphere&width=600&height=350&seq=card-03&orientation=landscape",
    title: "周末刷剧清单",
    desc: "精选 10 部高口碑短剧集，每部 12-24 集，一个周末就能刷完，适合忙碌的你。",
    tag: "追剧推荐",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Retro%201990s%20Chinese%20living%20room%20with%20CRT%20television%2C%20nostalgic%20warm%20sepia%20lighting%2C%20vintage%20furniture%2C%20old%20family%20photos%2C%20sentimental%20atmosphere%2C%20cinematic%20composition&width=600&height=350&seq=card-04&orientation=landscape",
    title: "那些年我们追过的剧",
    desc: "《还珠格格》《西游记》《新白娘子传奇》……重温陪伴我们成长的经典电视剧，满满的回忆杀。",
    tag: "怀旧经典",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20Chinese%20historical%20drama%20film%20set%2C%20camera%20crew%20and%20actors%20in%20costume%2C%20professional%20lighting%20equipment%2C%20cinematic%20production%20atmosphere%2C%20warm%20golden%20hour&width=600&height=350&seq=card-05&orientation=landscape",
    title: "幕后揭秘：大剧是怎样拍成的",
    desc: "走进《藏海传》拍摄现场，揭秘古装权谋大剧从剧本到成片的幕后制作故事。",
    tag: "幕后花絮",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Chinese%20actor%20and%20actress%20award%20ceremony%20red%20carpet%20moment%2C%20elegant%20formal%20attire%2C%20glamorous%20spotlight%2C%20prestigious%20atmosphere%2C%20cinematic%20event%20photography&width=600&height=350&seq=card-06&orientation=landscape",
    title: "2026 年国产剧演技大赏",
    desc: "盘点上半年表现最亮眼的十位演员，从老戏骨到新生代，谁是你心中的演技天花板？",
    tag: "人物盘点",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Traditional%20Chinese%20scholar%20study%20room%20with%20ancient%20scrolls%20and%20books%2C%20ink%20brush%20and%20paper%2C%20warm%20candlelight%2C%20literary%20atmosphere%2C%20cinematic%20depth%2C%20historical%20aesthetic&width=600&height=350&seq=card-07&orientation=landscape",
    title: "从小说到荧幕：IP 改编盘点",
    desc: "《长安的荔枝》《藏海传》等年度热门 IP 改编剧，原著与剧版的差异全解析。",
    tag: "IP 解读",
  },
];

export const appInfo = {
  title: "天堂影视 APP",
  desc: "下载天堂影视移动客户端，随时随地畅享高清追剧体验。支持离线缓存、夜间模式、倍速播放，更有 APP 专属剧集提前看。",
  features: ["离线缓存", "夜间模式", "倍速播放", "专属剧集", "弹幕互动"],
  qrImg: "https://readdy.ai/api/search-image?query=Minimalist%20QR%20code%20design%20with%20Chinese%20traditional%20pattern%20border%2C%20clean%20modern%20style%2C%20warm%20crimson%20and%20gold%20color%20scheme%2C%20elegant%20tech%20aesthetic&width=280&height=280&seq=app-qr&orientation=squarish",
};

export const faqItems = [
  {
    q: "天堂影视真的完全免费吗？需要注册会员吗？",
    a: "是的，天堂影视所有电视剧资源均可免费在线观看，无需注册、无需登录、无需付费。我们通过品牌合作与内容授权维持平台运营，不向用户收取任何费用，也不会在播放过程中插入广告。",
  },
  {
    q: "播放画质如何？支持哪些清晰度？",
    a: "天堂影视全站支持 1080P 超清和部分 4K 片源，并搭载智能码率自适应技术。系统会根据您的网络状况自动匹配最佳画质，确保无论使用 WiFi 还是移动数据都能流畅观看。您也可以手动选择标清、高清或超清模式。",
  },
  {
    q: "为什么有些剧集在其他平台需要 VIP 才能看？",
    a: "天堂影视通过与内容提供方的深度授权合作，获得了大量热门剧集的播放权。我们致力于打破付费壁垒，让优质内容触达每一位追剧爱好者。部分独家自制内容可能在其他平台付费，但在天堂影视仍可免费观看。",
  },
  {
    q: "剧集多久更新一次？新剧什么时候上线？",
    a: "平台内容每日更新，热门在播剧集通常与卫视首播同步，24 小时内完成上线。新剧完结后全集资源会第一时间整理入库。您可以通过首页「最新更新」时间线模块查看每日上新的具体剧集。",
  },
  {
    q: "支持哪些设备观看？可以投屏到电视吗？",
    a: "天堂影视支持 PC 浏览器、手机浏览器、平板电脑及智能电视投屏观看。移动端建议下载天堂影视 APP 获得最佳体验，支持 DLNA 和 AirPlay 投屏协议，轻松将精彩内容投到大屏幕上与家人共享。",
  },
];